import React from 'react';
import { GoalStageCoverage } from '../../types/v2';

const stages = ['define', 'do', 'explain', 'apply'] as const;

const stateLabel = (state?: string) => ({
  verified: 'Verified evidence',
  completed_unverified: 'Awaiting review',
  needs_revision: 'Needs revision',
  incomplete: 'Incomplete',
  not_assessed: 'No evidence recorded',
}[state || 'not_assessed'] || String(state || 'not assessed').replace(/_/g, ' '));

export const EvidenceCoverageSummary: React.FC<{
  coverage?: Record<'define' | 'do' | 'explain' | 'apply', GoalStageCoverage>;
  compact?: boolean;
}> = ({ coverage, compact = false }) => {
  const nextStage = stages.find((stage) => coverage?.[stage]?.state !== 'verified');
  return <div className="space-y-2">
    {!compact && <div className="rounded-lg bg-surface-alt p-3 text-sm text-muted"><span className="font-semibold text-text">Hook evidence trail:</span> DEFINE → DO → EXPLAIN → APPLY. {nextStage ? <>Next evidence stage: <span className="font-semibold text-text">{nextStage.toUpperCase()}</span>.</> : <span className="font-semibold text-text">Evidence is verified across all four stages.</span>} The teacher uses this trail when deciding whether to level up the student in Headrush.</div>}
    <div className={`grid gap-2 ${compact ? 'grid-cols-2 xl:grid-cols-4' : 'sm:grid-cols-2 lg:grid-cols-4'}`}>
    {stages.map((stage) => {
      const values = coverage?.[stage];
      return (
        <div key={stage} className="rounded-lg border border-border bg-surface-alt/50 p-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted">{stage}</p>
          <p className="mt-1 text-sm font-medium text-text">{stateLabel(values?.state)}</p>
          {!compact && values && (
            <p className="mt-1 text-xs text-muted">{values.verified_count}/{values.authored_count} verified</p>
          )}
          {values?.work_count !== undefined && <p className="mt-1 text-xs text-muted">{values.assessment_count || 0} assessment records · {values.work_count} work records</p>}
        </div>
      );
    })}
    </div>
  </div>;
};
